<template>
    <div class="day-description" :class="{ irrelevant: selectedIdx > latestDay }">
        <p>{{ text }}</p>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DayDescription',
    props: {
        selectedIdx: {
            type: Number,
            required: true
        },
        latestDay: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState({
            clinicDetail: state => state.patient.clinicDetail,
            locale: state => state.locale.locale
        }),
        text() {
            const dayTextKeys = {
                1: 'day_1_description',
                2: 'day_2_description',
                3: 'day_3_description',
                4: 'day_4_description',
                5: 'day_5_description'
            }
            if (
                this.clinicDetail.settings &&
                this.clinicDetail.settings.shareToPatientDayDescriptions &&
                this.clinicDetail.settings.shareToPatientDayDescriptions[this.selectedIdx]
            ) {
                return this.clinicDetail.settings.shareToPatientDayDescriptions[this.selectedIdx][
                    this.locale.code
                ]
            }

            return this.$translate(dayTextKeys[this.selectedIdx])
        }
    }
}
</script>

<style lang="scss" scoped>
.day-description {
    padding: 20px;
    color: $light-3;
    border-radius: 2px;
    background-color: $dark-3;

    p {
        margin-bottom: 0;
    }

    &.irrelevant {
        background-color: $light;
    }
}
</style>
